"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _commonReact = require("@devsta/common-react");

var _isMemoizePropsEqual = _interopRequireDefault(require("../utils/isMemoizePropsEqual"));

var _fileStatus = _interopRequireDefault(require("../../../../../../../common/constants/fileStatus"));

function wrappedImage(_ref) {
  var connectDragSource = _ref.connectDragSource,
      isUploaded = _ref.isUploaded,
      Image = _ref.Image;
  return isUploaded ? connectDragSource(Image) : Image;
}

function MockImage(props) {
  var status = props.status,
      asset = props.asset,
      connectDragSource = props.connectDragSource,
      isDragging = props.isDragging;
  var isUploaded = status === _fileStatus.default.UPLOADED;

  var Image = _react.default.createElement("div", {
    tabIndex: 0,
    role: "button",
    className: (0, _classnames.default)('shot-tab__image-wrapper', {
      'shot-tab__image-wrapper__dragging': isDragging,
      'shot-tab__image-wrapper__grab': isUploaded
    }),
    draggable: isUploaded.toString()
  }, _react.default.createElement(_commonReact.AssetPreview, {
    asset: asset
  }));

  return wrappedImage({
    Image: Image,
    isUploaded: isUploaded,
    connectDragSource: connectDragSource
  });
}

var _default = (0, _react.memo)(MockImage, _isMemoizePropsEqual.default);

exports.default = _default;